/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Dl_Faq_A7Inputs */

const en_pc_dl_faq_a7 = /** @type {(inputs: Pc_Dl_Faq_A7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not automatically. PdfCraft can ask GitHub whether a newer release exists, but it never downloads or installs anything on its own. The Linux AppImage can be updated with AppImageUpdate, and the ArtCraft Launcher can install and update PdfCraft for you.`)
};

const zh_pc_dl_faq_a7 = /** @type {(inputs: Pc_Dl_Faq_A7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不会自动更新。PdfCraft 可以向 GitHub 查询是否有新版本，但绝不会自行下载或安装任何东西。Linux 的 AppImage 可以用 AppImageUpdate 更新，ArtCraft Launcher 也可以帮你安装和更新 PdfCraft。`)
};

/**
* | output |
* | --- |
* | "Not automatically. PdfCraft can ask GitHub whether a newer release exists, but it never downloads or installs anything on its own. The Linux AppImage can be ..." |
*
* @param {Pc_Dl_Faq_A7Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_dl_faq_a7 = /** @type {((inputs?: Pc_Dl_Faq_A7Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Dl_Faq_A7Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_dl_faq_a7(inputs)
	return zh_pc_dl_faq_a7(inputs)
});
export { pc_dl_faq_a7 as "pc.dl.faq.a7" }